import React from "react";
import { getInstantValidationState } from '../../../utils/realTimeValidationUtils';

import './ASESShoulder.scss';

const ASESShoulder = ({ handleFormData, values, fieldErrors = {}, touchedFields = {} }) => {
  return (
    <div className="modern-assessment">
      <h2 className="assessment-title">ASES</h2>
      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion1', fieldErrors, touchedFields, values.ases.asesQuestion1);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              1. Heeft u pijn in uw schouder?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion1"
              required
              value={values.ases.asesQuestion1}
              onChange={(event) => handleFormData("ases", "asesQuestion1", event.target.value)}
              aria-label="Pijn in schouder"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Ja">Ja</option>
              <option value="Nee">Nee</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion2', fieldErrors, touchedFields, values.ases.asesQuestion2);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              2. Heeft u 's nachts pijn in uw schouder?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion2"
              required
              value={values.ases.asesQuestion2}
              onChange={(event) => handleFormData("ases", "asesQuestion2", event.target.value)}
              aria-label="Pijn 's nachts in schouder"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Ja">Ja</option>
              <option value="Nee">Nee</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion3', fieldErrors, touchedFields, values.ases.asesQuestion3);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              3. Gebruikt u pijnstillers (paracetamol, ibuprofen, etc.)?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion3"
              required
              value={values.ases.asesQuestion3}
              onChange={(event) => handleFormData("ases", "asesQuestion3", event.target.value)}
              aria-label="Gebruik van pijnstillers"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Ja">Ja</option>
              <option value="Nee">Nee</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion4', fieldErrors, touchedFields, values.ases.asesQuestion4);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              4. Gebruikt u recept-plichtige pijnstillers (tramadol, codeine of sterker)?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion4"
              required
              value={values.ases.asesQuestion4}
              onChange={(event) => handleFormData("ases", "asesQuestion4", event.target.value)}
              aria-label="Gebruik van recept-plichtige pijnstillers"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Ja">Ja</option>
              <option value="Nee">Nee</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion5', fieldErrors, touchedFields, values.ases.asesQuestion5);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              5. Hoeveel tabletten voor pijnstilling gebruikt u gemiddeld per dag?
            </label>
            <p className="modern-form-help">
              Van 0 tot 20 tabletten per dag
            </p>
            <div className={validation.inputClasses('modern-pain-slider')}>
              <input
                type="range"
                className={validation.inputClasses('modern-range-slider')}
                name="asesQuestion5"
                required
                value={values.ases.asesQuestion5 || ''}
                min="0"
                max="20"
                step="1"
                onChange={(event) => handleFormData("ases", "asesQuestion5", event.target.value)}
                aria-label="Aantal tabletten per dag"
                {...validation.ariaProps}
              />
              <input
                type="number"
                className={validation.inputClasses('modern-number-input')}
                name="asesQuestion5"
                required
                min="0"
                max="20"
                step="1"
                value={values.ases.asesQuestion5 || ''}
                onChange={(event) => handleFormData("ases", "asesQuestion5", event.target.value.trim())}
                aria-label="Aantal tabletten invoer"
                {...validation.ariaProps}
              />
            </div>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion6', fieldErrors, touchedFields, values.ases.asesQuestion6);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              6. Voelt uw schouder instabiel aan (alsof hij uit de kom gaat)?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion6"
              required
              value={values.ases.asesQuestion6}
              onChange={(event) => handleFormData("ases", "asesQuestion6", event.target.value)}
              aria-label="Instabiliteit van schouder"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Ja">Ja</option>
              <option value="Nee">Nee</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion7', fieldErrors, touchedFields, values.ases.asesQuestion7);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              7. Geef op de lijn aan hoe instabiel uw schouder is?
            </label>
            <p className="modern-form-help">
              Van 0 (geen instabiliteit) tot 10 (maximale instabiliteit)
            </p>
            <div className={validation.inputClasses('modern-pain-slider')}>
              <input
                type="range"
                className={validation.inputClasses('modern-range-slider')}
                name="asesQuestion7"
                required
                value={values.ases.asesQuestion7 || ''}
                min="0"
                max="10"
                step="0.1"
                onChange={(event) => handleFormData("ases", "asesQuestion7", event.target.value)}
                aria-label="Instabiliteit schaal"
                {...validation.ariaProps}
              />
              <input
                type="number"
                className={validation.inputClasses('modern-number-input')}
                name="asesQuestion7"
                required
                min="0"
                max="10"
                step="0.1"
                value={values.ases.asesQuestion7 || ''}
                onChange={(event) => handleFormData("ases", "asesQuestion7", event.target.value.trim())}
                aria-label="Instabiliteitswaarde invoer"
                {...validation.ariaProps}
              />
            </div>
            
          </div>
        );
      })()}

      <h3 className="assessment-subtitle">Kies het antwoord dat uw huidige status het best beschrijft bij het doen van de volgende activiteiten:</h3>      

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion8', fieldErrors, touchedFields, values.ases.asesQuestion8);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">8. Een jas aandoen?</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion8"
              required
              value={values.ases.asesQuestion8}
              onChange={(event) => handleFormData("ases", "asesQuestion8", event.target.value)}
              aria-label="Een jas aandoen"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Kan ik niet">Kan ik niet</option>
              <option value="Zeer moeilijk">Zeer moeilijk</option>
              <option value="Iets moeilijk">Iets moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion9', fieldErrors, touchedFields, values.ases.asesQuestion9);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">9. Slapen op de aangedane zijde?</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion9"
              required
              value={values.ases.asesQuestion9}
              onChange={(event) => handleFormData("ases", "asesQuestion9", event.target.value)}
              aria-label="Slapen op de aangedane zijde"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Kan ik niet">Kan ik niet</option>
              <option value="Zeer moeilijk">Zeer moeilijk</option>
              <option value="Iets moeilijk">Iets moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion10', fieldErrors, touchedFields, values.ases.asesQuestion10);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">10. De rug wassen / bh-bandje achteren sluiten?</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion10"
              required
              value={values.ases.asesQuestion10}
              onChange={(event) => handleFormData("ases", "asesQuestion10", event.target.value)}
              aria-label="De rug wassen / bh-bandje achteren sluiten"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Kan ik niet">Kan ik niet</option>
              <option value="Zeer moeilijk">Zeer moeilijk</option>
              <option value="Iets moeilijk">Iets moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion11', fieldErrors, touchedFields, values.ases.asesQuestion11);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">11. Gebruik van toilet?</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion11"
              required
              value={values.ases.asesQuestion11}
              onChange={(event) => handleFormData("ases", "asesQuestion11", event.target.value)}
              aria-label="Gebruik van toilet"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Kan ik niet">Kan ik niet</option>
              <option value="Zeer moeilijk">Zeer moeilijk</option>
              <option value="Iets moeilijk">Iets moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion12', fieldErrors, touchedFields, values.ases.asesQuestion12);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">12. Haar kammen?</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion12"
              required
              value={values.ases.asesQuestion12}
              onChange={(event) => handleFormData("ases", "asesQuestion12", event.target.value)}
              aria-label="Haar kammen"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Kan ik niet">Kan ik niet</option>
              <option value="Zeer moeilijk">Zeer moeilijk</option>
              <option value="Iets moeilijk">Iets moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion13', fieldErrors, touchedFields, values.ases.asesQuestion13);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">13. Hoge plank bereiken?</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion13"
              required
              value={values.ases.asesQuestion13}
              onChange={(event) => handleFormData("ases", "asesQuestion13", event.target.value)}
              aria-label="Hoge plank bereiken"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Kan ik niet">Kan ik niet</option>
              <option value="Zeer moeilijk">Zeer moeilijk</option>
              <option value="Iets moeilijk">Iets moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion14', fieldErrors, touchedFields, values.ases.asesQuestion14);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">14. 5 Kg boven schouderhoogte tillen?</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion14"
              required
              value={values.ases.asesQuestion14}
              onChange={(event) => handleFormData("ases", "asesQuestion14", event.target.value)}
              aria-label="5 Kg boven schouderhoogte tillen"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Kan ik niet">Kan ik niet</option>
              <option value="Zeer moeilijk">Zeer moeilijk</option>
              <option value="Iets moeilijk">Iets moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion15', fieldErrors, touchedFields, values.ases.asesQuestion15);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">15. Bovenhands een bal gooien?</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion15"
              required
              value={values.ases.asesQuestion15}
              onChange={(event) => handleFormData("ases", "asesQuestion15", event.target.value)}
              aria-label="Bovenhands een bal gooien"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Kan ik niet">Kan ik niet</option>
              <option value="Zeer moeilijk">Zeer moeilijk</option>
              <option value="Iets moeilijk">Iets moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion16', fieldErrors, touchedFields, values.ases.asesQuestion16);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">16. Normale werk doen?</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion16"
              required
              value={values.ases.asesQuestion16}
              onChange={(event) => handleFormData("ases", "asesQuestion16", event.target.value)}
              aria-label="Normale werk doen"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Kan ik niet">Kan ik niet</option>
              <option value="Zeer moeilijk">Zeer moeilijk</option>
              <option value="Iets moeilijk">Iets moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('ases.asesQuestion17', fieldErrors, touchedFields, values.ases.asesQuestion17);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">17. Normale sport doen?</label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="asesQuestion17"
              required
              value={values.ases.asesQuestion17}
              onChange={(event) => handleFormData("ases", "asesQuestion17", event.target.value)}
              aria-label="Normale sport doen"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Kan ik niet">Kan ik niet</option>
              <option value="Zeer moeilijk">Zeer moeilijk</option>
              <option value="Iets moeilijk">Iets moeilijk</option>
              <option value="Niet moeilijk">Niet moeilijk</option>
            </select>
            
          </div>
        );
      })()}
    </div>
  );
}

export default ASESShoulder;
